import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'nwt-power-supply-message-dialog',
  template:
  ` <div class="container">
      <mat-dialog-content>
        <strong> {{message}} </strong>
      </mat-dialog-content>
      <mat-dialog-actions class="d-flex justify-content-center action">
      <button mat-button mat-raised-button color="primary" type="button" (click)="onclickOK()"><strong style="color:white;">OK</strong></button>
      </mat-dialog-actions>
    </div>
  `,
  styleUrls: ['./power-supply-message-dialog.scss']
})
export class PowerSupplyMessageDialog implements OnInit {

  message: string = '';

  constructor(
    public dialogRef: MatDialogRef<PowerSupplyMessageDialog>,
    @Inject(MAT_DIALOG_DATA) private data,
    private router: Router) {
      this.message = this.data.message;
  }

  ngOnInit() {
  }

  onclickOK() {
    this.dialogRef.close();
    //this.router.navigate(['/powersupply']);
  }
}